module.exports = __webpack_public_path__ + "static/media/himanshu.39280593.jpeg";